/* gif-media.js — makes <video.gif-media> behave like a GIF everywhere.
   - Forces muted as a *property* (some browsers ignore the attribute alone)
   - Plays when in viewport, pauses off-screen (saves battery/CPU)
   - Retries on first touch for iOS Low Power Mode (which blocks autoplay) */
(function () {
  'use strict';

  function forcePlay(video) {
    video.muted = true;
    video.setAttribute('muted', '');
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function init() {
    var videos = Array.prototype.slice.call(
      document.querySelectorAll('video.gif-media')
    );
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) forcePlay(entry.target);
            else entry.target.pause();
          });
        },
        { threshold: 0.1 }
      );
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(forcePlay);
    }

    // iOS Low Power Mode: autoplay is blocked until a user gesture.
    document.addEventListener(
      'touchstart',
      function retry() {
        videos.forEach(function (v) {
          if (v.paused) forcePlay(v);
        });
      },
      { once: true, passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
